import {
  FETCH_ENCARGOS_REQUEST,
  FETCH_ENCARGOS_SUCCESS,
  FETCH_ENCARGOS_FAILURE,
} from "../actions/encargos/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ENCARGOS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ENCARGOS_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_ENCARGOS_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
